<template>
  <v-flex>
    <v-card flat light v-for="(item,i) in items" :key="i">
      <v-card-title primary-title>
        <v-flex text-xs-left>
          <div class="headline mb-0"><a :href="item.link">{{item.title}}</a></div>
          <span class="grey--text">{{item.date}}</span>
          <br>
          <span class="grey--text">{{item.tags}}</span>
          <br>
          {{item.desc}}
          <a :href="item.link">Read more ...</a>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  data: function() {
    return {
      items: [
        {
          title: "Fibonacci Numbers",
          date: "Aug 15, 2014",
          tags: "#tech #fibonacci numbers #dynamic programming #maths",
          link: "/tech-blog/fibonacci",
          desc:
            "Nature has always been a great inspiration for humans. We always try to find some patterns in nature and that led to the discovery of Fibonacci Numbers. The fibonacci sequence: 0 1 1 2 3 5 8 13 21 34 55 89 144 233 … Where the starting numbers of the sequence can either be 0 and 1 or 1 and 1 . By definition, the next term of the sequence is the sum of previous two."
        }
      ]
    };
  }
};
</script>